var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLoader),expression:"showLoader"}],staticClass:"tl-loader"})
}
var staticRenderFns = []

export { render, staticRenderFns }